import {
  DeserializedRecord,
  deserializeItem,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "../../../../Helpers";
import {deserializeMedium, Medium} from "../../../../Medium";

interface SectionMedium extends DeserializedRecord{
  medium: Medium
}

interface SectionMediumData extends JSONAPIRecord {
  relationships: {
    medium: JSONAPISingleRelationship
  }
}

type NewSectionMedium = Pick<SectionMedium, "medium">;

const deserializeSectionMedium: Deserializer<SectionMedium, SectionMediumData> = (data, included) => {
  const medium = deserializeSingleRelationship<Medium>(data.relationships.medium, included, deserializeMedium);

  return {
    medium,
    ...deserializeItem(data)
  };
};

export {
  SectionMedium, deserializeSectionMedium, NewSectionMedium
};
